export default __webpack_public_path__ + "images/10a93bafbb1a0ea5dec3e383b8d84249.svg";